import actions from './actions';

const {
  STUDENTS_ADD_BEGIN,
  STUDENTS_ADD_SUCCESS,
  STUDENTS_ADD_ERR,

  STUDENTS_READ_BEGIN,
  STUDENTS_READ_SUCCESS,
  STUDENTS_READ_ERR,

  STUDENTS_UPDATE_BEGIN,
  STUDENTS_UPDATE_SUCCESS,
  STUDENTS_UPDATE_ERR,
} = actions;

const initialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const AddinitialState = {
  data: [],
  url: null,
  fileLoading: false,
  loading: false,
  error: null,
};

const updateStateSingle = {
  data: null,
  loading: false,
  error: null,
};

const STUDENTSReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    
    case STUDENTS_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case STUDENTS_READ_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case STUDENTS_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};


const STUDENTSAddReducer = (state = AddinitialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case STUDENTS_ADD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case STUDENTS_ADD_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case STUDENTS_ADD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

const STUDENTSUpdateReducer = (state = updateStateSingle, action) => {
  const { type, data, err } = action;
  switch (type) {
    
    case STUDENTS_UPDATE_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case STUDENTS_UPDATE_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case STUDENTS_UPDATE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};


export { STUDENTSReducer, STUDENTSUpdateReducer, STUDENTSAddReducer };
